export default __webpack_public_path__ + "static/media/Apercu-Medium.987283d5.otf";